import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";

// Import pages
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Games from "./pages/Games";
import Ranks from "./pages/Ranks";
import AboutUs from "./pages/AboutUs";

/*
  This is the root of the entire website.
  It always renders the Header component, which contains the logo, clan name and navigation.
  It also always renders the Footer component.
  It also conditionally renders the correct page depending on the current URL.
*/
const App = () => {
  return (
    <Router>
      <div className="app">
        <Header />
        <div className="main-contents">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/games" element={<Games />} />
            <Route path="/ranks" element={<Ranks />} />
            <Route path="/aboutus" element={<AboutUs />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
